// import { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { getMe } from "../services/apiService";

// export default function ProtectedRoute({ children }) {
//   const [loading, setLoading] = useState(true);
//   const [authenticated, setAuthenticated] = useState(false);

//   useEffect(() => {
//     getMe()
//       .then(() => setAuthenticated(true))
//       .catch(() => setAuthenticated(false))
//       .finally(() => setLoading(false));
//   }, []);

//   // ⏳ Prevent flashing content
//   if (loading) return null;

//   // 🔐 Auth decision
//   return authenticated ? children : <Navigate to="/login" replace />;
// }
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMe } from "../services/apiService";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    getMe()
      .then((res) => {
        console.log("GET ME SUCCESS:", res);
        setAuthenticated(true);
      })
      .catch((err) => {
        console.error("GET ME ERROR:", err);
        setAuthenticated(false);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 20 }}>Checking session...</div>;

  return authenticated ? children : <Navigate to="/login" replace />;
}